<div class="status-box">
  <div class="status-container">
    <div class="image-box">
      <img
        src="{{ 'assets/img/Close-Circle.png' | xeaSourcePath }}"
        class="status-image"
      />
    </div>
    <div class="message-box">
      <div class="status-title">{{ errorTitle | translate }}</div>
      <div class="status-message">{{ message | translate }}</div>
    </div>
  </div>
</div>
